export default {
  home: '首页',
  login: '登录',
  components: '系统管理',
  user_manage: '用户管理',
  menu_manage: '菜单管理',
  role_manage: '角色管理',
  map_manage: '地图展示',
  map1_manage: '地图展示',
  setting_manage: '系统配置',
  count_to_page: '数字渐变',
  count_to_page1: '数字渐变',
  monitor: '系统监控',
  betting_analyse: '投注分析',
  quartz_manage: '定时任务',
  dict_manage: '数据字典管理',
  i18n_manage: '国际化管理',
  message_manage: '公告管理',
  message_detail: '发送消息详情',
  log_manage: '操作日志管理',
  add_message: '消息详情',
  betting_analysis_manage: '投注详情管理',
  betting: '投注分析',
  team_manage: '球队管理',
  tables_page: '多功能表格',
  split_pane_page: '分割窗口',
  markdown_page: 'Markdown编辑器',
  editor_page: '富文本编辑器',
  icons_page: '自定义图标',
  img_cropper_page: '图片编辑器',
  update: '上传数据',
  join_page: 'QQ群',
  doc: '文档',
  update_table_page: '上传CSV文件',
  update_paste_page: '粘贴表格数据',
  multilevel: '多级菜单',
  directive_page: '指令',
  level_1: 'Level-1',
  level_2: 'Level-2',
  level_2_1: 'Level-2-1',
  level_2_3: 'Level-2-3',
  level_2_2: 'Level-2-2',
  level_2_2_1: 'Level-2-2-1',
  level_2_2_2: 'Level-2-2-2',
  excel: 'Excel',
  'upload-excel': '上传excel',
  'export-excel': '导出excel',
  tools_methods_page: '工具函数',
  drag_list_page: '拖拽列表',
  i18n_page: '多语言',
  modalTitle: '模态框题目',
  content: '这是模态框内容',
  buttonText: '显示模态框',
  'i18n-tip': '注：仅此页做了多语言，其他页面没有在多语言包中添加语言内容',
  error_store_page: '错误收集',
  error_logger_page: '错误日志',
  query: '带参路由',
  params: '动态路由',
  cropper_page: '图片裁剪',
  message_page: '消息中心',
  tree_table_page: '树状表格',
  org_tree_page: '组织结构树',
  drag_drawer_page: '可拖动抽屉',
  tree_select_page: '树状下拉选择器'
}



// WEBPACK FOOTER //
// ./src/locale/lang/zh-CN.js